export const en = {
    any: 'Any',
    common: 'Common',
    coupe: '2d class',
    lux: '1st class',
    reserved: '3d class',
    seat: 'Seat',
    vip: 'VIP',
};
